const template = require('./template');

module.exports = template;
